import { Button, Card, Form } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowAltCircleLeft } from '@fortawesome/free-regular-svg-icons';
import { useForm } from 'react-hook-form';
import { useEffect, useMemo, useState } from 'react';

import {
    faCheck,
    faEdit,
    faInfoCircle,
    faRedo,
    faSave,
    faTimes,
    faUpload,
    faFolder
} from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';
import {
    useParams
} from 'react-router-dom';

import { AESDecrypt, AESEncrypt } from '../../../encrypt-util';
import { AppDispatch, RootState } from '../template/store';
import { useDispatch, useSelector } from 'react-redux';
// import { getEBLDetails } from '../actions/eBLDetailActions';
import { getEBLDetails, getEBLHistory } from './actions/eBLActions';

const EBLDetails = () => {

    const { encrypt, blId } = useParams();
    const blNumber = useSelector((state: RootState) => state.oblDetails.oblForm.number);

    const dispatch = useDispatch<AppDispatch>();

    const {
        register,
        handleSubmit,
        reset,
        setValue,
        watch,
        setError,
        trigger,
        clearErrors,
        formState: { errors, touchedFields },
    } = useForm();

    const currentTitleHolder = useSelector((state: RootState) => state.eblDetails.titleHolder);
    const currentCustodian = useSelector((state: RootState) => state.eblDetails.custodian);

    const { t } = useTranslation();

    const onSubmit = handleSubmit(async (payload) => {
        
    });

    useEffect(() => {
        if(blNumber){
            dispatch(getEBLHistory({ eBLNo: blNumber }))
        }
    }, [blNumber])

    useEffect(() => {
        if(blNumber){
            dispatch(getEBLDetails({ eBLNo: blNumber }))
        }
    }, [blNumber])

    useEffect(() => {

        if (currentTitleHolder) {
            setValue('currentTitleHolder', currentTitleHolder)
        }
        if (currentCustodian) {
            setValue('currentCustodian', currentCustodian)
        }

    }, [blNumber, currentTitleHolder, currentCustodian])


    return (

        <div className='container'>

            <Form autoComplete='off'>
                <br />
                <div className='row'>
                    <div
                        className={`col-6 mb-3`}
                    >
                        <Form.Group>
                            <Form.Label className='fs--1'>
                                Current Title Holder
                                <span>
                                    {' '}
                                </span>
                            </Form.Label>
                            <Form.Control
                                size='sm'
                                {...register('currentTitleHolder')}
                                value={watch('currentTitleHolder')}
                                className={`fs--1 col-12 mb-1 form-control ${errors.currentTitleHolder ? 'is-invalid' : ''
                                    }`}
                                disabled={true}
                            />
                            <div className='invalid-feedback'>
                                {errors.currentTitleHolder?.message?.toString()}
                            </div>
                        </Form.Group>
                    </div>
                    <div
                        className={`col-6 mb-3`}
                    >
                        <Form.Group>
                            <Form.Label className='fs--1'>
                                Current Custodian
                                <span>
                                    {' '}
                                </span>
                            </Form.Label>
                            <Form.Control
                                size='sm'
                                {...register('currentCustodian')}
                                value={watch('currentCustodian')}
                                className={`fs--1 col-6 mb-1 form-control ${errors.currentCustodian ? 'is-invalid' : ''
                                    }`}
                                disabled={true}
                            />
                            <div className='invalid-feedback'>
                                {errors.currentCustodian?.message?.toString()}
                            </div>
                        </Form.Group>
                    </div>
                </div>
                <br />
            </Form>
        </div>
    );
};

export default EBLDetails;
